/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import PluginCard from "../ui/PluginCard";
import Icon from "../ui/Icon";
import DiscountBadge from "./DiscountBadge";
import { useCart } from "../../hooks/useCart";
import { CART_LINE_TYPES, DISCOUNT_TYPE } from "../../constants/constants";
import FormatDuration from "../formatters/FormatDuration";
import AddToCartControls from "../AddToCartControls";
import styled from "styled-components";
import Flex from "../ui/Flex";

const StyledDiscountBadge = styled(DiscountBadge)`
  align-self: start;
`;

const PromotionItem = React.memo(({ promotion }) => {
  const { findLine, addLine, removeLine } = useCart();

  const existing = findLine(
    CART_LINE_TYPES.PROMOTION,
    (params) => +params.promotion_id === +promotion.id
  );
  const inCart = !!existing;
  const itemIcon = promotion.discount_type === DISCOUNT_TYPE.PERCENTAGE ? <Icon.Promotion size="90px" color="iconStroke" strokeWidth={1} /> : <Icon.GiftCard size="90px" strokeWidth={3} />;
  const includes = [{ icon: <Icon.CalendarDetailed />, name: <FormatDuration value={promotion.duration} type={promotion.duration_type} /> }];


  const handleAdd = () =>
    addLine({
      type: CART_LINE_TYPES.PROMOTION,
      entity: promotion,
      params: { promotion_id: promotion.id },
    });

  const handleRemove = () => {
    if (existing) removeLine({ clientId: existing.clientId });
  };

  const controls = (
    <AddToCartControls
      inCart={inCart}
      onAdd={() => handleAdd()}
      onRemove={() => handleRemove()}
    />
  );

  const promotionModalFooter = (
    <Flex $direction="column" $gap="0.5rem">
      <StyledDiscountBadge
        discount={promotion.discount}
        discountType={promotion.discount_type}
        currency={promotion.currency}
      />
      {controls}
    </Flex>
  );

  return (
    <PluginCard
      name={promotion.name}
      price={promotion.price}
      currency={promotion.currency}
      description={promotion.description}
      picture={promotion.picture_preview}
      fallbackIcon={itemIcon}
      isSelected={inCart}
      includes={includes}
      beforeFooter={<DiscountBadge
        discount={promotion.discount}
        discountType={promotion.discount_type}
        currency={promotion.currency}
      />}
      footer={controls}
      modalFooter={promotionModalFooter}
      closeOnSelect
    />
  );
});

export default PromotionItem;
